// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zai-side-chat-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100%;
  box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.0784313725);
  background: linear-gradient(136.74deg, #7723ff 5.56%, #5f3d85 97.31%);
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-side-chat-button/zai-side-chat-button.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;EACA,qEAAA;EACA,SAAA;AACF","sourcesContent":[".zai-side-chat-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 100%;\n  box-shadow: 0px 2px 10px 1px #00000014;\n  background: linear-gradient(136.74deg, #7723ff 5.56%, #5f3d85 97.31%);\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
